import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var checkUsernameRes;
export const checkUsernameTodo = createAsyncThunk('checkUsername', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + `username_available_check`,
            params: {
                "user_name": data?.user_name,
            },
            headers: { "Content-Type": "application/json" }
        })
        return checkUsernameRes = res

    } catch (error) {
        return checkUsernameRes = error.response
    }
})